import React from 'react';
import styled from 'styled-components';
import { DeleteOutlined, MoreOutlined } from '@ant-design/icons';
import { Dropdown, Menu, message, Modal } from 'antd';
import { useDeleteQueryMutation } from '../../../../../../graphql/query.generated';
import { useTranslation } from '../../../../../../i18n/useTranslation';

const StyledMoreOutlined = styled(MoreOutlined)`
    font-size: 14px;
`;

export type Props = {
    urn: string;
    onDeleted?: (urn: string) => void;
    index?: number;
};

export default function QueryCardDetailsMenu({ urn, onDeleted, index }: Props) {
    const [deleteQueryMutation] = useDeleteQueryMutation();
    const { t } = useTranslation();
    const deleteQuery = () => {
        deleteQueryMutation({ variables: { urn } })
            .then(({ errors }) => {
                if (!errors) {
                    message.success({
                        content: t('Deleted Query!'),
                        duration: 3,
                    });
                    onDeleted?.(urn);
                }
            })
            .catch(() => {
                message.destroy();
                message.error({ content: t('Failed to delete Query! An unexpected error occurred') });
            });
    };

    const confirmDeleteQuery = () => {
        Modal.confirm({
            centered: true,
            title: t('Delete Query'),
            content: t('Are you sure you want to delete this query?'),
            onOk() {
                deleteQuery();
            },
            onCancel() {},
            okText: t('Yes'),
            cancelText: t('Cancel'),
            maskClosable: true,
            closable: true,
        });
    };

    return (
        <Dropdown
            overlay={
                <Menu>
                    <Menu.Item
                        key="0"
                        onClick={confirmDeleteQuery}
                        data-testid={`query-delete-button-${index}`}
                        aria-label={t('Delete')}
                    >
                        <DeleteOutlined /> &nbsp; {t('Delete')}
                    </Menu.Item>
                </Menu>
            }
            trigger={['click']}
        >
            <StyledMoreOutlined data-testid={`query-more-button-${index}`} tabIndex={0} />
        </Dropdown>
    );
}
